
import { Link } from "react-router-dom";
import { useAuth0 } from '@auth0/auth0-react';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import '../../assets/css/argon-dashboard-react.css';
// reactstrap components
import {
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FaUserCircle } from 'react-icons/fa'; // Import FontAwesome user circle icon
import './AuthNavbar.css';

const AdminNavbar = () => {
  const { loginWithRedirect, isAuthenticated, logout, user } = useAuth0();
  const location = useLocation();
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const [imgError, setImgError] = useState(false);

  return (
    <>
      <Navbar className="navbar-top navbar-horizontal navbar-dark">
        <Container className="px-3">
          <NavbarBrand to="/" tag={Link}>
            <img
              alt="..."
              src={require("../../assets/img/brand/ZipQuillTransparent.webp")}
              style={{ filter: 'invert(1) brightness(2)' }}
            />
          </NavbarBrand>
          <Nav className="ml-auto navbar-nav navbar-dark" navbar>
            {isAuthenticated && user && (
              <>
                <NavItem>
                  <NavLink className="nav-link-icon text-shadow nav-link-small" to="/User/Home" tag={Link}>
                    <i className="ni ni-planet" />
                    <span className="nav-link-inner--text">My Quills</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon text-shadow nav-link-small"
                    to="/store"
                    tag={Link}
                  >
                    <i className="ni ni-basket" />
                    <span className="nav-link-inner--text">Shop</span>
                  </NavLink>
                </NavItem>

                {/* Profile Dropdown */}
                <Dropdown
                    nav
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                    className="d-flex align-items-center position-relative"
                  >
                    <DropdownToggle nav className="d-flex align-items-center pl-4" style={{ padding: '4px', borderRadius: '8px' }}>
                      {user.picture && !imgError ? (
                        <img
                          src={user.picture}
                          className="rounded"
                          alt="profile"
                          onError={() => setImgError(true)}
                          style={{
                            width: '30px',
                            height: '30px',
                            objectFit: 'cover',
                            marginRight: '8px',
                            borderRadius: '8px',
                          }}
                        />
                      ) : (
                        <FaUserCircle
                          style={{
                            fontSize: '30px',
                            color: '#fff',
                            marginRight: '8px',
                            borderRadius: '8px', 
                            backgroundColor: '#333', 
                            padding: '5px',
                          }}
                        />
                      )}
                    </DropdownToggle>
                    <DropdownMenu
                      end
                      className="dropdown-menu-responsive"
                    >
                      <DropdownItem tag={Link} to="/User/Profile">Profile</DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem
                        onClick={() =>
                          logout({ logoutParams: { returnTo: window.location.origin } })
                        }
                      >
                        Logout
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>




              </>
            )}
            {!isAuthenticated && (
              <>
                <NavItem>
                  <NavLink
                    className="nav-link-icon text-shadow nav-link-small"
                    to="/store"
                    tag={Link}
                  >
                    <i className="ni ni-basket" />
                    <span className="nav-link-inner--text">Shop</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon text-shadow nav-link-small"
                    to="#"
                    tag={Link}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default navigation
                      loginWithRedirect({
                        authorizationParams: {
                          screen_hint: "signup",
                        },
                      });
                    }}
                  >
                    <i className="ni ni-circle-08" />
                    <span className="nav-link-inner--text">Register</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="nav-link-icon text-shadow nav-link-small"
                    to="#"
                    tag={Link}
                    onClick={(e) => {
                      e.preventDefault(); // Prevent default navigation
                      loginWithRedirect(); // Trigger Auth0 login
                    }}
                  >
                    <i className="ni ni-key-25" />
                    <span className="nav-link-inner--text">Login</span>
                  </NavLink>
                </NavItem>
              </>
            )}
          </Nav>
        </Container>
      </Navbar>
    </>
  );
};

export default AdminNavbar;
